import React from "react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeftCircle } from "lucide-react";

export default function NotFound() {
  const [_, setLocation] = useLocation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 via-black to-emerald-950 text-white px-4">
      <div className="text-center">
        <h1 className="text-6xl font-extrabold mb-4 text-emerald-400">404</h1>
        <h2 className="text-2xl font-bold mb-2">Page Not Found</h2>
        <p className="text-gray-400 mb-8">Sorry, the page you are looking for does not exist or has been moved.</p>
        <Button
          onClick={() => setLocation("/")}
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 mx-auto"
        >
          <ArrowLeftCircle className="h-5 w-5" />
          Back to Home
        </Button>
      </div>
    </div>
  );
}
